import { render, staticRenderFns } from "./ListLayout.vue?vue&type=template&id=a20efdc6&scoped=true"
import script from "./ListLayout.vue?vue&type=script&lang=js"
export * from "./ListLayout.vue?vue&type=script&lang=js"
import style0 from "./ListLayout.vue?vue&type=style&index=0&id=a20efdc6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a20efdc6",
  null
  
)

export default component.exports